<template>
	<div class="tab-poll">
		<div class="tab-poll-title"
			:style="`color:${$appColors.primary}`"
		>NOMBRE DE LA ENCUESTA</div>
		<v-radio-group v-model="radios">
      <v-radio 
				v-for="poll in polls"
				:key="poll.id"
				:label="poll.name" 
				:value="poll.id"
				color="success">
			</v-radio>
    </v-radio-group>
	</div>
</template>
<script>

function data() {
	return {
		radios: null,
	};
}

function created() {
	this.changePoll(this.pollId);
}

function radios(value) {
	this.$emit('select-poll', value);
}

function pollId(value) {
	this.changePoll(value);
}

function changePoll(value) {
	this.radios = value || this.polls[0].id;
}

export default {
	name: 'tab-poll',
	created,
	data,
	methods: {
		changePoll,
	},
	props: {
		polls: {
			type: [Array, Object],
			default: () => [],
		},
		pollId: Number,
	},
	watch: {
		radios,
		pollId,
	},
};
</script>
<style lang="scss">
	.tab-poll {
		.v-radio {
			border-bottom: 1px solid map-get($colors, gray-slider);
			flex-direction: row-reverse;
			justify-content: space-between;
			margin: 0px;
			padding: 15px 26px;
		}

		.v-input__control {
			width: 100%;
		}

		.v-label {
			font-size: map-get($sizes, small);
		}

		.v-input--selection-controls {
			margin-top: 0;
		}

		&-title {
			border-bottom: 1px solid map-get($colors, gray-slider);
			font-size: map-get($sizes, small);
			padding: 18px 0;
			text-align: center;
		}
	}
</style>





// WEBPACK FOOTER //
// src/components/diagnosis/tab-poll.vue